import React from "react";
import { Carousel } from "react-bootstrap";
import { IMG1,IMG2,IMG3, IMG4, IMG5, IMG6 } from "../assets/images";

const Hero = () => {
  return (
    <Carousel>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG1}
          alt="school  1"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG2}
          alt="school  2"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG3}
          alt="school 3"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG4}
          alt="school  1"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG5}
          alt="school  2"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          loading="lazy"
          className="d-block w-100"
          src={IMG6}
          alt="school 3"
        />
      </Carousel.Item>
    </Carousel>
  );
};

export default Hero;
